// rraCallClient — the front-line call sheet's AUTHENTICATED client
// (/rra-call/:token), RRA v2.1 (W3; F2). Not public any more: every call-sheet
// route needs the ordinary staff sign-in (and RRA_CALLERS membership when that
// roster is set), so this uses the `api` helper — the Bearer token, one
// refresh-and-retry on a 401. The token in the path still addresses the
// verification; the caller's name is the sign-in (the typed "Your name" field
// is cut).
//
// The wire shapes and all of the page's logic (form state, validation, payload
// building, script text) live in the pure module lib/rraCallSheet.ts, which is
// re-exported here so callers import everything from one place.

import { api } from '@/lib/api';
import type { RraCallBody, RraCallSubmissionResult, RraCallView } from './rraCallSheet';

export * from './rraCallSheet';

const callPath = (token: string) => `/api/rra-call/${encodeURIComponent(token)}`;

export function getRraCall(token: string): Promise<RraCallView> {
  return api.get<RraCallView>(callPath(token));
}

export function submitRraCall(token: string, body: RraCallBody): Promise<RraCallSubmissionResult> {
  return api.post<RraCallSubmissionResult>(callPath(token), body);
}

/** THIS verifier's copy of the signed request, as bytes for an object-URL iframe. */
export function fetchRraCallCopy(token: string): Promise<Blob> {
  return api.blob(`${callPath(token)}/copy.pdf`, 'application/pdf');
}
